import * as React from "react";
import axios from 'axios';
import Avatar from "@mui/material/Avatar";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import Link from "@mui/material/Link";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { Link as RouteLink } from "react-router-dom";
import AuthContext from '../../context/auth-context';

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://tokaiiran.com/">
        tokaiiran.com
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

const theme = createTheme({
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      "IRANYekan",
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
});

const SignUp = props => {
  React.useEffect(() => {
    document.getElementsByTagName('body')[0].style.backgroundColor = '#fff'
  }, []);
  const authContext = React.useContext(AuthContext);

  const handleSubmit = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // const email = data.get("email");
    const password = data.get("password");
    const firstname = data.get("firstname");
    const lastname = data.get("lastname");
    const mobile = data.get("mobile");
    if (mobile !== "" && password !== "") {
      axios
        // .post("http://api.localhost:5000/signup", {
        .post("https://admin.tokaiiran.com/api/signup", {
          password,
          firstname,
          lastname,
          mobile
        })
        .then((res) => {
          const data = res.data;
          if (data.status !== 200) {
            authContext.messageType("warning");
          } else {
            authContext.messageType("success");
            authContext.login(data);
            props.history.replace("/");
          }
          authContext.message(data.message);
          authContext.showSnackBar(true);
        })
        .catch((err) => console.log(err));
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Grid container component="main" sx={{ minHeight: "100vh" }}>
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: "url(https://picsum.photos/640/780)",
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
          <Box
            sx={{
              my: 8,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <Avatar
              alt="Tokai Iran"
              src="/assets/images/logo01.png"
              sx={{ width: 34, height: 41, borderRadius: 0 }}
            />
            <Typography component="h1" variant="h5" sx={{ my: 1 }}>
              ثبت نام
            </Typography>
            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ mt: 1 }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="firstname"
                label="نام"
                name="firstname"
                autoComplete="firstname"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                id="lastname"
                label="نام خانوادگی"
                name="lastname"
                autoComplete="lastname"
              />
              {/* <TextField
                margin="normal"
                required
                fullWidth
                id="email"
                label="ایمیل"
                name="email"
                dir="ltr"
                autoComplete="email"
              /> */}
              <TextField
                margin="normal"
                required
                fullWidth
                id="mobile"
                label="موبایل"
                dir="ltr"
                name="mobile"
                autoComplete="mobile"
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="password"
                label="کلمه عبور"
                type="password"
                id="password"
                dir="ltr"
                autoComplete="current-password"
              />
              <FormControlLabel
                className="label-has-checkbox"
                control={<Checkbox value="remember" color="primary" />}
                label="آخرین اخبار را برای من ارسال کن"
              />
              <Button
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 3, mb: 2 }}
              >
                ثبت نام
              </Button>
              <Grid container className="rtl">
                <Grid item xs={12} md={6} sx={{ mb: 2 }}>
                  <Link component={RouteLink} to="/login" variant="body2">
                    قبلا ثبت نام کرده‌اید ؟ ورود
                  </Link>
                </Grid>
              </Grid>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
}

export default SignUp;